import React from 'react';
import { Button } from 'react-bootstrap';
import { GenericModal } from './GenericModal';

export const ConfirmActionModal = ({
    show,
    handleClose,
    onConfirm,
    title = "Confirm Action",
    message = "Are you sure you want to proceed?",
    confirmText = "Confirm",
    // cancelText = "Cancel",
    variant = "danger"
}) => {

    const handleConfirmClick = () => {
        try {
            onConfirm();
        } catch (error) {
            console.error('Action failed:', error);
        }
    };

    return (
        <GenericModal
            show={show}
            handleClose={handleClose}
            title={title}
            footerActions={
                <>
                    <Button variant={variant} onClick={handleConfirmClick}>{confirmText}</Button>
                </>
            }
        >
            <p className="fs-5">{message}</p>
        </GenericModal>
    );
};
